/**
 * Formatação de CNPJ: padrão XX.XXX.XXX/XXXX-XX (ex: 12.423.997/0001-71)
 */

/** Máscara incremental para o input — aplica pontuação conforme o usuário digita */
export const mascararCNPJ = (valor: string): string => {
  const d = valor.replace(/\D/g, '').slice(0, 14);
  if (d.length > 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
  if (d.length > 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`;
  if (d.length > 5) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`;
  if (d.length > 2) return `${d.slice(0, 2)}.${d.slice(2)}`;
  return d;
};

/** Retorna o CNPJ formatado se tiver 14 dígitos; senão retorna o valor original trimado */
export const formatarCNPJ = (valor?: string | null): string => {
  if (!valor) return '';
  const d = String(valor).replace(/\D/g, '');
  if (d.length !== 14) return String(valor).trim();
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
};

/**
 * Converte número digitado em formato BR para number.
 * Aceita: "1.500,50", "1500,50", "1500.50", "1.500" (milhar) — sem limite de tamanho.
 * Retorna NaN para valores não numéricos.
 */
export const parseNumeroBR = (valor?: string | number | null): number => {
  if (valor === null || valor === undefined) return NaN;
  if (typeof valor === 'number') return valor;
  const v = String(valor).trim();
  if (!v) return NaN;
  if (v.includes(',')) {
    // padrão BR: ponto = separador de milhar, vírgula = decimal
    return Number(v.replace(/\./g, '').replace(',', '.'));
  }
  return Number(v);
};

/** Filtro de digitação para campos decimais: só dígitos, vírgula e ponto */
export const filtrarNumeroDecimal = (valor: string): string =>
  valor.replace(/[^\d.,]/g, '');
